import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { AddressContainer, ImageContainer, InnerContainer } from './styles'
import { ReactComponent as LocationImg } from 'assets/TimeLocation/locationNew.svg'
import { IconFilled } from 'components/IconsContainers/styled'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { handleLocalStorage } from 'featureSliced/shared/hooks/handleLocalStorage'

export const Location = () => {
  const t = useTranslations()
  const color = useMySelector((state) => state.app.interfaceStyles.FontColor)
  const restaurants = useMySelector((state) => state.restaurants)

  const dataEnc = handleLocalStorage('dataEnc')

  const getRestTitle = () => {
    return (
      restaurants?.find((rest) => {
        return rest?.dataEnc === dataEnc
      })?.title || ''
    )
  }

  const getRestAddress = () => {
    return (
      restaurants?.find((rest) => {
        return rest?.dataEnc === dataEnc
      })?.address || ''
    )
  }

  return (
    <InnerContainer>
      <ImageContainer>
        <IconFilled color={color}>
          <LocationImg />
        </IconFilled>
      </ImageContainer>
      <AddressContainer>
        <p>{t('clickCollect.pickUpLocation')}:</p>
        <p>
          {getRestTitle()}, {getRestAddress()}
        </p>
      </AddressContainer>
    </InnerContainer>
  )
}
